import { databases } from "@/lib/appwrite";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const PROFILE_COLLECTION_ID = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID;

type UpdateWorkerInput = {
  // Nombre separado
  firstName?: string;
  middleName?: string;
  lastName?: string;
  secondLastName?: string;
  // Acceso
  email?: string;
  // Datos personales
  birthday?: string;
  bloodType?: string;
  colabDniCode?: string;
  phone1?: string;
  phone2?: string;
  emergencyContact?: string;
  address?: string;
  // Datos corporativos
  joinDate?: string;
  rolCorp?: string;
  occupation?: string;
  occupationAbbreviation?: string;
  colabCorpCode?: string;
  area?: string;
  idSupervisor?: string;
  departmentId?: string;
  isActive?: boolean;
  leaveDate?: string;
  // Datos bancarios
  bank?: string;
  bankAccountNumber?: string;
  bankAccountType?: string;
  // Otros
  keyFunctions?: string;
  keyFunction?: string[];
  archievements?: string;
  archievement?: string[];
};

export async function updateWorkerProfile(
  userId: string,
  profileId: string,
  data: UpdateWorkerInput
) {
  await databases.updateDocument(
    DATABASE_ID,
    PROFILE_COLLECTION_ID,
    profileId,
    {
      userId,
      // Nombre
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      secondLastName: data.secondLastName,
      // Acceso
      email: data.email,
      // Personales
      birthday: data.birthday,
      bloodType: data.bloodType,
      colabDniCode: data.colabDniCode,
      phone1: data.phone1,
      phone2: data.phone2,
      emergencyContact: data.emergencyContact,
      address: data.address,
      // Corporativos
      joinDate: data.joinDate,
      rolCorp: data.rolCorp,
      occupation: data.occupation,
      occupationAbbreviation: data.occupationAbbreviation,
      colabCorpCode: data.colabCorpCode,
      area: data.area,
      idSupervisor: data.idSupervisor,
      departmentId: data.departmentId,
      isActive: data.isActive,
      leaveDate: data.leaveDate,
      // Bancarios
      bank: data.bank,
      bankAccountNumber: data.bankAccountNumber,
      bankAccountType: data.bankAccountType,
      // Otros
      keyFunctions: data.keyFunctions,
      keyFunction: data.keyFunction,
      archievements: data.archievements,
      archievement: data.archievement,
    }
  );
}